import React from "react";
import PropTypes from "prop-types";
import {
  HashRouter as Router,
  Route,
  NavLink,
  Redirect,
  Switch,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSuitcase,
  faUsers,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import Kanban from "../Kanban";
import JobProfile from "../JobProfile";
import EmployerProfile from "../EmployerProfile";
import withTracker from "./withTracker";
import applicationType from "../Kanban/types/applicationType";
import employerProfileType from "../EmployerProfile/types/employerProfileType";
import jobProfileType from "../JobProfile/types/jobProfileType";
import jobStatusWidgetType from "../JobProfile/types/jobStatusWidgetType";
import {
  RouterNav,
  RouterList,
  RouterItem,
  TabIcon,
  TabText,
} from "./styles/router-nav-styles";

const RecruiterJobHubTabNavigation = ({
  applications,
  employerProfile,
  getActionBarData,
  isRecruiter,
  cvLimitFull,
  jobProfile,
  newCandidatesLink,
  submittedCandidates,
  jobStatusWidget,
  engagementId,
  jobCurrencySymbol,
  jobId,
  showAvgResponseTime,
  isPortalUser,
  recruiterCompanyName,
}) => {
  const {
    slides,
    description,
    showProfileCompletion,
    isPortalEmployer,
    isPremiumEmployer,
  } = employerProfile;

  const JobProfilePage = (newProps) => (
    <JobProfile
      {...newProps}
      jobProfile={jobProfile}
      isRecruiter={isRecruiter}
      cvLimitFull={cvLimitFull}
      getActionBarData={getActionBarData}
      jobStatusWidget={jobStatusWidget}
      isPortalUser={isPortalUser}
      recruiterCompanyName={recruiterCompanyName}
    />
  );

  const EmployerProfilePage = (newProps) => (
    <EmployerProfile
      {...newProps}
      slides={slides}
      description={description}
      showProfileCompletion={showProfileCompletion}
      isRecruiter={isRecruiter}
      isPortalEmployer={isPortalEmployer}
      isPremiumEmployer={isPremiumEmployer}
      cvLimitFull={cvLimitFull}
      showAvgResponseTime={showAvgResponseTime}
    />
  );
  const KanbanPage = (newProps) => (
    <Kanban
      {...newProps}
      applications={applications}
      isRecruiter={isRecruiter}
      engagementId={engagementId}
      jobCurrencySymbol={jobCurrencySymbol}
      jobId={jobId}
      cvLimitFull={cvLimitFull}
      newCandidatesLink={newCandidatesLink}
      submittedCandidates={submittedCandidates}
    />
  );

  return (
    <Router>
      <RouterNav id="tab-nav">
        <RouterList>
          <RouterItem>
            <NavLink to="/job-profile" activeClassName="active">
              <TabIcon>
                <FontAwesomeIcon icon={faSuitcase} />
              </TabIcon>
              <TabText>Job Profile</TabText>
            </NavLink>
          </RouterItem>
          <RouterItem>
            <NavLink to="/employer-profile">
              <TabIcon>
                <FontAwesomeIcon icon={faUserCircle} />
              </TabIcon>
              <TabText>Employer</TabText>
            </NavLink>
          </RouterItem>
          <RouterItem>
            <NavLink to="/candidates">
              <TabIcon>
                <FontAwesomeIcon icon={faUsers} />
              </TabIcon>
              <TabText>Candidates</TabText>
            </NavLink>
          </RouterItem>
        </RouterList>
      </RouterNav>
      <Switch>
        <Route
          exact
          path="/job-profile"
          component={withTracker(JobProfilePage)}
        />
        <Route
          exact
          path="/employer-profile"
          component={withTracker(EmployerProfilePage)}
        />
        <Route path="/candidates" component={withTracker(KanbanPage)} />
        <Route
          exact
          path="/"
          render={() => <Redirect from="/" to="/candidates" />}
        />
      </Switch>
    </Router>
  );
};

RecruiterJobHubTabNavigation.propTypes = {
  applications: PropTypes.arrayOf(applicationType).isRequired,
  employerProfile: employerProfileType.isRequired,
  getActionBarData: PropTypes.func.isRequired,
  isRecruiter: PropTypes.bool,
  cvLimitFull: PropTypes.bool,
  jobProfile: jobProfileType.isRequired,
  newCandidatesLink: PropTypes.string.isRequired,
  submittedCandidates: PropTypes.string.isRequired,
  jobStatusWidget: jobStatusWidgetType,
  engagementId: PropTypes.number.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired,
  showAvgResponseTime: PropTypes.bool,
  isPortalEmployer: PropTypes.bool,
  isPremiumEmployer: PropTypes.bool,
  isPortalUser: PropTypes.bool.isRequired,
  recruiterCompanyName: PropTypes.string.isRequired,
};

RecruiterJobHubTabNavigation.defaultProps = {
  isRecruiter: null,
  cvLimitFull: null,
  jobStatusWidget: null,
  showAvgResponseTime: null,
  isPortalEmployer: null,
  isPremiumEmployer: null,
};

export default RecruiterJobHubTabNavigation;
